import { autoinject, computedFrom } from 'aurelia-framework';
import { Store } from "aurelia-store";
import { IState } from "../../../store/state";
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { StatusColors } from "../../common/status-colors";
import { createDarkText, createLightText } from "../../common/common-functions";

import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";

@autoinject
export class DecentlabWaterLevel extends TemperatureBaseDevice {

	constructor(store: Store<IState>, api: Api, i18n: I18N) {
		super(store, api, i18n);
	}

	activate(device: Device) {
		this.device = device;
	}
	attached() {
		if (this.tooltip) {
			//this.tooltip.position = "bottom";
			this.tooltip.html = this.buildToolTip();
		}

	}

	@computedFrom('device.data')
	get levelStyle(): string {
		if (this.device.data === undefined || this.device.data.pressure === undefined) {
			return null;
		}
		const level = this.calculateLevel();
		const nearestLevel = Math.ceil(+level / 10) * 10;
		return nearestLevel === 100 ? "tank-100" : nearestLevel === 0 ? "tank-0" : `tank-${nearestLevel}`;
	}

	@computedFrom('device.styles')
	get levelColor(): string {
		if (this.device.styles === undefined || this.device.styles.pressure === undefined ) {
			return null;
		}
		return this.device.styles.pressure;
	}

	@computedFrom('device.data')
	get level(): string {
		if (this.device.data === undefined || this.device.data.pressure === undefined || this.device.properties.length === 0) {
			return null;
		}
		return `${this.calculateLevel()}%`;
	}

	calculateLevel(): string {
		const level = (this.device.data.pressure / +this.device.properties.nominalPressure.value) * 100;
		if (isNaN(level) || level < 0) {
			return "0.0";
		}
		return (level >= 100 ? 100 : level).toFixed(1);
	}

}